import { createContext, useContext } from 'react';

export const DetailsPaneCloseContext = createContext<(() => void) | null>(null);

export function useDetailsPaneClose(): (() => void) | null {
    return useContext(DetailsPaneCloseContext);
}
